import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { activateAccount, me } from "../../services/auth";

export default function ActivateAccount() {
  const { token } = useParams();

  const [loading, setLoading] = useState(true);
  const [valid, setValid] = useState(false);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (token) {
      setValid(true);
    } else {
      setError("El enlace de activación no es válido o ha expirado.");
    }
    setLoading(false);
  }, [token]);

  async function handleSubmit(e) {
    e.preventDefault();

    if (password !== confirm) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    try {
      await activateAccount(token, password);

      const res = await me();
      const user = res?.user;

      setSuccess(true);

      setTimeout(() => {
        if (user?.onboarding_completed) {
          window.location.href = "/dashboard";
        } else {
          window.location.href = "/welcome";
        }
      }, 1000);
    } catch (err) {
      setError(err.message || "No se pudo activar la cuenta.");
    }
  }

  if (loading) {
    return (
      <main className="z-auth-page">
        <div className="z-auth-shell">
          <section className="z-auth-card">
            <h1 className="z-auth-title">Validando enlace…</h1>
          </section>
        </div>
      </main>
    );
  }

  if (!valid) {
    return (
      <main className="z-auth-page">
        <div className="z-auth-shell">
          <section className="z-auth-card">
            <div className="z-auth-alert z-auth-alert--error">{error}</div>
          </section>
        </div>
      </main>
    );
  }

  if (success) {
    return (
      <main className="z-auth-page">
        <div className="z-auth-shell">
          <section className="z-auth-card">
            <div className="z-auth-kicker">Cuenta activa</div>
            <h1 className="z-auth-title">Tu acceso ya está listo</h1>
            <p className="z-auth-subtitle">Redirigiendo…</p>
          </section>
        </div>
      </main>
    );
  }

  return (
    <main className="z-auth-page">
      <div className="z-auth-shell">
        <section className="z-auth-card">
          <div className="z-auth-kicker">Activación</div>

          <h1 className="z-auth-title">Crear tu contraseña</h1>

          <p className="z-auth-subtitle">
            Define tu contraseña para activar tu acceso a ZEDRO Academy.
          </p>

          <form className="z-auth-form z-auth-stack" onSubmit={handleSubmit}>
            {error && (
              <div className="z-auth-alert z-auth-alert--error">
                {error}
              </div>
            )}

            <input
              className="z-auth-input"
              type={showPassword ? "text" : "password"}
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="new-password"
            />

            <input
              className="z-auth-input"
              type={showPassword ? "text" : "password"}
              placeholder="Confirmar contraseña"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              autoComplete="new-password"
            />

            <label className="z-auth-check">
              <input
                type="checkbox"
                checked={showPassword}
                onChange={() => setShowPassword(!showPassword)}
              />
              <span>Mostrar contraseña</span>
            </label>

            <button type="submit" className="z-auth-btn">
              Activar cuenta
            </button>
          </form>
        </section>
      </div>
    </main>
  );
}